import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import { Heading, ContainerBox } from './AdminStyle';
import InvoiceTable from '../Tables/InvoiceTable';

@inject('residenceBookingStore', 'userStore', 'adminStore', 'partnersStore')

@observer
class Invoices extends Component {

  componentWillMount() {
    this.props.adminStore.getInvoices()
    this.props.partnersStore.listPartners()
  }

  onAddNewInvoice = () => {
    this.props.history.push(`/internal/admin/invoices/new`);
  }

  render() {
    const { isAdmin, isLoge } = this.props.userStore;
    const { invoices } = this.props.adminStore;

    const sentInvoices = invoices ? invoices.filter(invoice => invoice.runningNumber !== -1) : null
    const pendingInvoices = invoices ? invoices.filter(invoice => invoice.runningNumber === -1) : null

    // console.log(this.props.partnersStore);
    console.log(this.props.partnersStore.isLoading);

    return (
      <div>
      {(isAdmin || isLoge )  ?
          <div>
            <Row style={{maxWidth: 1200, margin: "0 auto"}}>
              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox>
                  <Heading>Rechnungen</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table invoices'}>
                    <InvoiceTable data={ !this.props.partnersStore.isLoading ? sentInvoices : [] } onRowClick="details" search pagination hide={["contract", "type"]}/>
                  </div>
                </ContainerBox>
                <ContainerBox>
                  <Heading>Manuelle Freigabe</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table invoices'}>
                    <InvoiceTable data={ !this.props.partnersStore.isLoading ? pendingInvoices : [] } onRowClick="details" search pagination hide={["invoiceNumber", "contract", "type", "paid", "link"]}/>
                  </div>
                </ContainerBox>
              </Col>
            </Row>
          </div>
          : ''}
      </div>
    )
  }
}

export default Invoices



// WEBPACK FOOTER //
// /src/components/admin/Invoices.js